export const formatEventDate = (dateStart: string, dateEnd: string): string => {
  const startDate = new Date(dateStart);
  const endDate = new Date(dateEnd);

  const formatOptions: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };

  const startFormatted = startDate.toLocaleDateString('ru-RU', formatOptions);

  if (startDate.toDateString() === endDate.toDateString()) {
    return startFormatted;
  }

  const endFormatted = endDate.toLocaleDateString('ru-RU', formatOptions);

  const sameYear = startDate.getFullYear() === endDate.getFullYear();
  const sameMonth = startDate.getMonth() === endDate.getMonth();

  if (sameYear && sameMonth) {
    return `${startDate.getDate()} — ${endFormatted}`;
  }

  if (sameYear) {
    const endWithoutYear = endDate.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long',
    });
    return `${startFormatted} — ${endWithoutYear}`;
  }

  return `${startFormatted} — ${endFormatted}`;
};
